import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Компонент для установки заголовка страницы
 */
export function PageTitle({ title }: { title: string }) {
  const location = useLocation();

  useEffect(() => {
    const oldTitle = document.title;
    if (title) document.title = title;
    // following line is optional, but will reset title when component unmounts
    return () => {
      document.title = oldTitle;
    };
  }, [location, title]);

  return null;
}
